import ViewReverse from './ViewReverse';
import Text from './Text';
import { fontSizes } from '../constants/constants';
import dynamicfunction from '../utils/dynamicfunction';
import { ReactSVG } from 'react-svg';
import icons from '../constants/icons';
import { cn } from '../utils/utils';

const CustomCheckbox = ({ isChecked, label, onClick, className, secondText, isError, onPressSecondText, disabled }) => {
  const { TextWeight } = dynamicfunction();
  return (
    <ViewReverse className={`items-start gap-2 ${className}`}>
      <div
        className={cn(
          'w-5 h-5 min-w-5 min-h-5 flex items-center justify-center rounded cursor-pointer border',
          isChecked ? 'bg-primary' : 'bg-transparent',
          isError ? 'border-red-500' : isChecked ? 'border-primary' : 'border-grey',
        )}
        onClick={disabled ? null : onClick}
      >
        {isChecked && <ReactSVG src={icons?.check} />}
      </div>
      {label && (
        <ViewReverse className={'w-full flex-wrap'}>
          <Text text={label} size={fontSizes.h14} weight={TextWeight.light} className={'me-2'} isTruncate={false} />
          {secondText && (
            <Text
              text={secondText}
              size={fontSizes.h14}
              color={'text-primary'}
              weight={TextWeight.bold}
              className={'-mx-1 cursor-pointer'}
              onClick={onPressSecondText}
              isTruncate={false}
            />
          )}
        </ViewReverse>
      )}
    </ViewReverse>
  );
};

export default CustomCheckbox;
